// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.features {
  padding: 4rem 2rem;
  background-color: #0C111B;
  position: relative;
  overflow: hidden;
}

.features::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  right: -50%;
  bottom: -50%;
  background: radial-gradient(circle at center, rgba(20, 241, 149, 0.05) 0%, rgba(0, 0, 0, 0) 70%);
  z-index: 0;
  animation: pulse-bg 10s ease-in-out infinite;
}

@keyframes pulse-bg {
  0%, 100% { opacity: 0.5; }
  50% { opacity: 0.7; }
}

.section-header {
  text-align: center;
  margin-bottom: 3rem;
  position: relative;
  z-index: 1;
}

.section-header h2 {
  font-size: 2.5rem;
  color: white;
  margin-bottom: 1rem;
  text-shadow: 0 0 20px rgba(153, 69, 255, 0.3);
  background: linear-gradient(to right, #ffffff, #9945FF);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.section-header p {
  font-size: 1.1rem;
  color: #9BA5B7;
  max-width: 700px;
  margin: 0 auto;
}

.highlight {
  color: #9945FF;
  font-weight: 600;
  position: relative;
}

.highlight::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 100%;
  height: 2px;
  background: linear-gradient(to right, #9945FF, #14F195);
  opacity: 0.7;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, auto);
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}

.feature-card {
  background: linear-gradient(145deg, #131b2c, #0e1520);
  border-radius: 16px;
  padding: 2rem;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border: 1px solid rgba(255, 255, 255, 0.05);
  position: relative;
  overflow: hidden;
}

.feature-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background: linear-gradient(90deg, #9945FF, #14F195);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.feature-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.4), 0 0 20px rgba(153, 69, 255, 0.2);
}

.feature-card:hover::before {
  opacity: 1;
}

.feature-icon-container {
  width: 80px;
  height: 80px;
  background: linear-gradient(145deg, #172238, #0d1320);
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.5rem;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
  position: relative;
  border: 1px solid rgba(153, 69, 255, 0.1);
}

.feature-svg {
  width: 40px;
  height: 40px;
  color: #9945FF;
  filter: drop-shadow(0 0 8px rgba(153, 69, 255, 0.6));
}

.pulse-path {
  animation: pulse 2s ease-in-out infinite;
}

.glow-circle {
  animation: glow 2s ease-in-out infinite;
  filter: drop-shadow(0 0 5px rgba(20, 241, 149, 0.8));
}

@keyframes pulse {
  0%, 100% { stroke-width: 2; opacity: 0.8; }
  50% { stroke-width: 3; opacity: 1; }
}

@keyframes glow {
  0%, 100% { opacity: 0.6; }
  50% { opacity: 1; }
}

.feature-card h3 {
  font-size: 1.4rem;
  color: white;
  margin-bottom: 1rem;
  background: linear-gradient(to right, #ffffff, #9945FF);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.feature-card p {
  color: #9BA5B7;
  line-height: 1.6;
}

/* Code-like decoration for feature cards */
.feature-card::after {
  content: "{ }";
  position: absolute;
  top: 15px;
  right: 15px;
  font-size: 1.2rem;
  color: rgba(153, 69, 255, 0.2);
  font-family: monospace;
}

@media (max-width: 768px) {
  .features {
    padding: 3rem 1rem;
  }
  
  .section-header h2 {
    font-size: 2rem;
  }
  
  .features-grid {
    grid-template-columns: 1fr;
    grid-template-rows: repeat(4, auto);
  }
  
  .feature-icon-container {
    width: 70px;
    height: 70px;
  }
  
  .feature-svg {
    width: 32px;
    height: 32px;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/FeaturesSection.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,gGAAgG;EAChG,UAAU;EACV,4CAA4C;AAC9C;;AAEA;EACE,WAAW,YAAY,EAAE;EACzB,MAAM,YAAY,EAAE;AACtB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,6CAA6C;EAC7C,uDAAuD;EACvD,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,WAAW;EACX,WAAW;EACX,uDAAuD;EACvD,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,mCAAmC;EACnC,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,qDAAqD;EACrD,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,qDAAqD;EACrD,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,WAAW;EACX,oDAAoD;EACpD,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;EAC5B,4EAA4E;AAC9E;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qDAAqD;EACrD,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,yCAAyC;EACzC,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oDAAoD;AACtD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,uCAAuC;EACvC,oDAAoD;AACtD;;AAEA;EACE,WAAW,eAAe,EAAE,YAAY,EAAE;EAC1C,MAAM,eAAe,EAAE,UAAU,EAAE;AACrC;;AAEA;EACE,WAAW,YAAY,EAAE;EACzB,MAAM,UAAU,EAAE;AACpB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,uDAAuD;EACvD,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,2CAA2C;AAC3C;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,mCAAmC;EACrC;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":[".features {\n  padding: 4rem 2rem;\n  background-color: #0C111B;\n  position: relative;\n  overflow: hidden;\n}\n\n.features::before {\n  content: '';\n  position: absolute;\n  top: -50%;\n  left: -50%;\n  right: -50%;\n  bottom: -50%;\n  background: radial-gradient(circle at center, rgba(20, 241, 149, 0.05) 0%, rgba(0, 0, 0, 0) 70%);\n  z-index: 0;\n  animation: pulse-bg 10s ease-in-out infinite;\n}\n\n@keyframes pulse-bg {\n  0%, 100% { opacity: 0.5; }\n  50% { opacity: 0.7; }\n}\n\n.section-header {\n  text-align: center;\n  margin-bottom: 3rem;\n  position: relative;\n  z-index: 1;\n}\n\n.section-header h2 {\n  font-size: 2.5rem;\n  color: white;\n  margin-bottom: 1rem;\n  text-shadow: 0 0 20px rgba(153, 69, 255, 0.3);\n  background: linear-gradient(to right, #ffffff, #9945FF);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.section-header p {\n  font-size: 1.1rem;\n  color: #9BA5B7;\n  max-width: 700px;\n  margin: 0 auto;\n}\n\n.highlight {\n  color: #9945FF;\n  font-weight: 600;\n  position: relative;\n}\n\n.highlight::after {\n  content: '';\n  position: absolute;\n  bottom: -2px;\n  left: 0;\n  width: 100%;\n  height: 2px;\n  background: linear-gradient(to right, #9945FF, #14F195);\n  opacity: 0.7;\n}\n\n.features-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  grid-template-rows: repeat(2, auto);\n  gap: 2rem;\n  max-width: 1200px;\n  margin: 0 auto;\n  position: relative;\n  z-index: 1;\n}\n\n.feature-card {\n  background: linear-gradient(145deg, #131b2c, #0e1520);\n  border-radius: 16px;\n  padding: 2rem;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n  border: 1px solid rgba(255, 255, 255, 0.05);\n  position: relative;\n  overflow: hidden;\n}\n\n.feature-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 4px;\n  background: linear-gradient(90deg, #9945FF, #14F195);\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.feature-card:hover {\n  transform: translateY(-10px);\n  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.4), 0 0 20px rgba(153, 69, 255, 0.2);\n}\n\n.feature-card:hover::before {\n  opacity: 1;\n}\n\n.feature-icon-container {\n  width: 80px;\n  height: 80px;\n  background: linear-gradient(145deg, #172238, #0d1320);\n  border-radius: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 1.5rem;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);\n  position: relative;\n  border: 1px solid rgba(153, 69, 255, 0.1);\n}\n\n.feature-svg {\n  width: 40px;\n  height: 40px;\n  color: #9945FF;\n  filter: drop-shadow(0 0 8px rgba(153, 69, 255, 0.6));\n}\n\n.pulse-path {\n  animation: pulse 2s ease-in-out infinite;\n}\n\n.glow-circle {\n  animation: glow 2s ease-in-out infinite;\n  filter: drop-shadow(0 0 5px rgba(20, 241, 149, 0.8));\n}\n\n@keyframes pulse {\n  0%, 100% { stroke-width: 2; opacity: 0.8; }\n  50% { stroke-width: 3; opacity: 1; }\n}\n\n@keyframes glow {\n  0%, 100% { opacity: 0.6; }\n  50% { opacity: 1; }\n}\n\n.feature-card h3 {\n  font-size: 1.4rem;\n  color: white;\n  margin-bottom: 1rem;\n  background: linear-gradient(to right, #ffffff, #9945FF);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.feature-card p {\n  color: #9BA5B7;\n  line-height: 1.6;\n}\n\n/* Code-like decoration for feature cards */\n.feature-card::after {\n  content: \"{ }\";\n  position: absolute;\n  top: 15px;\n  right: 15px;\n  font-size: 1.2rem;\n  color: rgba(153, 69, 255, 0.2);\n  font-family: monospace;\n}\n\n@media (max-width: 768px) {\n  .features {\n    padding: 3rem 1rem;\n  }\n  \n  .section-header h2 {\n    font-size: 2rem;\n  }\n  \n  .features-grid {\n    grid-template-columns: 1fr;\n    grid-template-rows: repeat(4, auto);\n  }\n  \n  .feature-icon-container {\n    width: 70px;\n    height: 70px;\n  }\n  \n  .feature-svg {\n    width: 32px;\n    height: 32px;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
